import React from 'react';
import ClassAssembly  from 'views/ClassAssembly9C2023';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;